export default __webpack_public_path__ + "static/media/binance.2d77e387.svg";